"use client";

import { DEFAULT_SORT, SORT_OPTIONS, type SortKey } from "../../lifestyle-constants";
import { SortIcon } from "../lifestyleIcons";
import DropdownOption from "./DropdownOption";
import FilterDropdown from "./FilterDropdown";

interface SortDropdownProps {
  selected: SortKey;
  onSelect: (sort: SortKey) => void;
  /** Mobile swaps the inline menu for SortSheet, which the page renders. */
  onOpenSheet: () => void;
}

export default function SortDropdown({ selected, onSelect, onOpenSheet }: SortDropdownProps) {
  const selectedLabel =
    selected === DEFAULT_SORT ? null : (SORT_OPTIONS.find(option => option.key === selected)?.label ?? null);

  return (
    <FilterDropdown
      label="Sort by"
      selectedLabel={selectedLabel}
      compact
      icon={<SortIcon className="shrink-0 w-6 h-6" />}
      onOpenMobileSheet={onOpenSheet}
      className="shrink-0 w-10 lg:w-[160px]">
      {close => (
        <div className="flex flex-col min-w-[220px]">
          {SORT_OPTIONS.map(option => (
            <DropdownOption
              key={option.key}
              label={option.label}
              isSelected={option.key === selected}
              onSelect={() => {
                onSelect(option.key);
                close();
              }}
            />
          ))}
        </div>
      )}
    </FilterDropdown>
  );
}
